import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import logo from "../../images/logo.webp";
import styles from "./NavBar.module.css";
const NavBar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [hoveredLinkIndex, setHoveredLinkIndex] = useState(null);
  const [currentTime, setCurrentTime] = useState(getAlbuquerqueTime());

  function getAlbuquerqueTime() {
    return new Date().toLocaleTimeString("en-US", {
      timeZone: "America/Denver",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  const handleLogout = async () => {
    try {
      await logout();
      setMenuOpen(false);
      navigate("/admin-login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const handleLogoClick = () => {
    setMenuOpen(false);
    navigate("/");
  };

  const handleToggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(getAlbuquerqueTime());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/inquiry", label: "Inquiry" },
    { path: "/aftercare", label: "Aftercare" },
    { path: "/booking-policy", label: "Booking Policy" },
  ];

  return (
    <>
      <header className={styles.header}>
        <NavLink to="/gallery" className={`${styles.sideBtn} ${styles.leftBtn}`} onClick={closeMenu}>
          GALLERY
        </NavLink>
        <div className={styles.centerLogo}>
          <img
            src={logo}
            alt="Marléna Logo"
            className={styles.logoImage}
            onClick={handleLogoClick}
          />
        </div>
        <button
          type="button"
          onClick={handleToggleMenu}
          className={`${styles.sideBtn} ${styles.rightBtn}`}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
        >
          {menuOpen ? "CLOSE" : "MENU"}
        </button>
      </header>
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className={styles.menuPanel}
            initial={{
              opacity: 0,
              clipPath: "circle(0% at 50% 0%)",
            }}
            animate={{
              opacity: 1,
              clipPath: "circle(150% at 50% 0%)",
            }}
            exit={{
              opacity: 0,
              clipPath: "circle(0% at 50% 0%)",
            }}
            transition={{
              duration: 0.55,
              ease: [0.76, 0, 0.24, 1],
            }}
          >
            <motion.div
              className={styles.menuTopRow}
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 10, opacity: 0 }}
              transition={{
                duration: 0.45,
                delay: 0.1,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              <span>ALBUQUERQUE, (NM)</span>
              <span className={styles.menuDivider}>{"//"}</span>
              <span className={styles.timeDotGroup}>
                <span className={styles.blinkDot}></span>
                {currentTime}
              </span>
            </motion.div>
            <nav className={styles.menuNav} aria-label="Main navigation">
              {navItems.map(({ path, label }, index) => (
                <motion.div
                  key={path}
                  initial={{ y: 40, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: 20, opacity: 0 }}
                  transition={{
                    duration: 0.45,
                    delay: 0.12 + index * 0.055,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                >
                  <NavLink
                    to={path}
                    onClick={closeMenu}
                    onMouseEnter={() => setHoveredLinkIndex(index)}
                    onMouseLeave={() => setHoveredLinkIndex(null)}
                    className={({ isActive }) =>
                      `${styles.menuLink} ${isActive ? styles.active : ""} ${
                        hoveredLinkIndex !== null && hoveredLinkIndex !== index
                          ? styles.otherMenuLinks
                          : ""
                      }`
                    }
                  >
                    {label}
                  </NavLink>
                </motion.div>
              ))}
              {user && (
                <motion.div
                  initial={{ y: 40, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: 20, opacity: 0 }}
                  transition={{
                    duration: 0.45,
                    delay: 0.12 + navItems.length * 0.055,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                >
                  <button onClick={handleLogout} className={styles.logoutBtn}>
                    Logout
                  </button>
                </motion.div>
              )}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
export default NavBar;
